'use client';

import { useEffect, useState } from 'react';
import { getCookie, setCookie } from 'cookies-next';

import useLanguageConflictChecker from '@/hooks/useLanguageConflictChecker';

import LanguageConfirmationDialog from './LanguageConfirmationDialog';

const LanguageConflictHelper = ({
  newParams,
  updateURL,
}: {
  newParams: any;
  updateURL: URL;
}) => {
  const hasLocaleParam = getCookie('hasLocaleParam');
  const [languageConfirmationDialog, setLanguageConfirmationDialog] =
    useState(false);
  const {
    isLoading,
    isLanguageConflict,
    currentLanguage,
    savedLanguage,
    user,
  } = useLanguageConflictChecker({
    accessToken: newParams.accessToken || '',
    tenantId: newParams.tenantId || '',
    tenantName: newParams.tenantName || '',
  });

  useEffect(() => {
    if (!isLoading && hasLocaleParam === 'true') {
      if (isLanguageConflict) {
        setLanguageConfirmationDialog(true);
      } else {
        window.location.replace(updateURL as URL);
      }
    }
  }, [isLanguageConflict, isLoading, updateURL, hasLocaleParam]);

  useEffect(() => {
    if (hasLocaleParam === 'false' && savedLanguage !== null) {
      updateURL?.searchParams?.set('locale', savedLanguage);
      setCookie('NEXT_LOCALE', savedLanguage);
      window.location.replace(updateURL as URL);
    }
  }, [hasLocaleParam, savedLanguage, updateURL]);

  return (
    <div>
      {languageConfirmationDialog && (
        <LanguageConfirmationDialog
          savedLanguage={savedLanguage || ''}
          currentLanguage={currentLanguage || ''}
          userId={user?.id || ''}
          accessToken={newParams.accessToken}
          tenantId={newParams.tenantId}
          tenantName={newParams.tenantName}
          isOpen={languageConfirmationDialog}
          onClose={() => {
            setLanguageConfirmationDialog(false);
          }}
          updateURL={updateURL as URL}
        />
      )}
    </div>
  );
};

export default LanguageConflictHelper;
